import { render, staticRenderFns } from "./Warehouse.vue?vue&type=template&id=3623ac4c"
import script from "./Warehouse.vue?vue&type=script&lang=js"
export * from "./Warehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports